// @flow
export const dataKey: 'dishes' = 'dishes';
